import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategoryNav() {
  const [active, setActive] = useState('all');

  return (
    <section id="categories" className="w-full px-4 md:px-6 py-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-lg font-bold text-foreground-900 mb-4">视频分类</h2>
        <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
          <button
            onClick={() => setActive('all')}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
              active === 'all'
                ? 'bg-primary-500 text-foreground-950'
                : 'bg-background-200 text-foreground-500 hover:text-foreground-900 hover:bg-background-300'
            }`}
          >
            全部
          </button>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              onClick={() => setActive(cat.slug)}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                active === cat.slug
                  ? 'bg-primary-500 text-foreground-950'
                  : 'bg-background-200 text-foreground-500 hover:text-foreground-900 hover:bg-background-300'
              }`}
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}